import { useLayoutEffect } from 'react';
import { useQuery } from 'react-query';
import { contentAPI } from '../services/api';
import { applySiteFavicon } from '../utils/applySiteFavicon';
import { applySiteDocumentTitle } from '../utils/applySiteDocumentTitle';
import { DEFAULT_ADMIN_DOCUMENT_TITLE } from '../utils/siteTitleDefaults';

let cachedAdminDocumentTitle = DEFAULT_ADMIN_DOCUMENT_TITLE;

function cacheAdminDocumentTitle(title) {
  const t = String(title ?? '').trim();
  if (t) cachedAdminDocumentTitle = t;
}

export function getCachedAdminDocumentTitle() {
  return cachedAdminDocumentTitle;
}

/** Applies site favicon and admin browser tab title (login + panel). */
export default function SiteFavicon() {
  const { data } = useQuery(
    ['site-settings-branding'],
    async () => {
      const res = await contentAPI.getSiteSettings();
      return res.data?.data ?? res.data ?? {};
    },
    { staleTime: 60_000, retry: 2, refetchOnWindowFocus: true }
  );

  const faviconUrl = data?.site_favicon_url ?? '';
  const adminTitle = data?.site_admin_title ?? '';

  useLayoutEffect(() => {
    applySiteFavicon(faviconUrl);
  }, [faviconUrl]);

  useLayoutEffect(() => {
    const resolved = String(adminTitle || '').trim() || DEFAULT_ADMIN_DOCUMENT_TITLE;
    const previousCached = cachedAdminDocumentTitle;
    cacheAdminDocumentTitle(resolved);
    const current = typeof document !== 'undefined' ? String(document.title || '').trim() : '';
    const stillSiteDefault =
      !current ||
      current === previousCached ||
      current === DEFAULT_ADMIN_DOCUMENT_TITLE ||
      current === resolved;
    if (stillSiteDefault) {
      applySiteDocumentTitle(adminTitle, DEFAULT_ADMIN_DOCUMENT_TITLE);
    }
  }, [adminTitle]);

  return null;
}
